import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { AppNotifications, FORM_MODE, RootState } from "../../../models";
import { AgentService } from "../../../services";
import { NotificationActions } from "../../../store/actions";
import AgentFormPresenter from "./AgentForm.presenter";
import { C_Props, C_States, MapDispatchToProps, MapStateToProps, MergedProps } from "./AgentForm.type";
import { loadCallback } from "../../../utils";
import { withRouter } from "react-router-dom";
import _ from "lodash";

class AgentFormContainer extends Component<MergedProps, C_States> {
  constructor(props) {
    super(props);

    const mode = this.props.initial ? FORM_MODE.EDIT : FORM_MODE.CREATE;

    this.state = {
      mode,
      loading: false,
      initData: this.props.initial || null,
      agentStatus: {
        status: true,
      },
    };
  }

  onSubmit = (val: any) => {
    let data: any = {
      ...val,
      status: val.status ? "publish" : "unpublish",
      isSendMail: false,
    };
    data = _.pickBy(data, (v) => !_.isUndefined(v));

    if (this.state.mode === FORM_MODE.CREATE) {
      this.onCreateAgent(data);
    } else {
      this.onUpdateAgent(data);
    }
  };

  onChangeAgentStatus = (status: boolean) => {
    this.setState((prevState) => {
      return {
        agentStatus: {
          ...prevState.agentStatus,
          status,
        },
      };
    });
  };

  onCreateAgent = (data) => {
    AgentService.createAgent(data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Create partner success",
          });
          loadCallback(this.props.onComplete_Create);
        } else if (res) {
          if (res.status === 409) {
            if (res.data?.message === "EMAIL_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Email existed." });
            } else if (res.data?.message === "PHONE_EXISTED") {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Phone number existed." });
            } else {
              this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create partner failed" });
            }
          }
        } else {
          this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create partner failed" });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({ type: AppNotifications.ERROR, message: "Create partner failed" });
      });
  };

  onUpdateAgent = (data) => {
    AgentService.updateAgent(this.props.agentId!, data)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.SUCCESS,
            message: "Update partner success",
          });
          loadCallback(this.props.onComplete_Update);
        } else {
          this.props.actions.enqueueSnackbar({
            type: AppNotifications.ERROR,
            message: "Update partner failed",
          });
        }
      })
      .catch((err) => {
        this.props.actions.enqueueSnackbar({
          type: AppNotifications.ERROR,
          message: "Update partner failed",
        });
      });
  };  

  render() {
    return (
      <AgentFormPresenter
        {...this.props}
        {...this.state}
        onSubmit={this.onSubmit}
        onChangeAgentStatus={this.onChangeAgentStatus}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({}),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions), dispatch),
    })
  )(AgentFormContainer)
);
